import { useEffect } from 'react';
import Smartlook from 'smartlook-client';

const COOKIE_NAME = 'smartlook_user_id';
const COOKIE_DOMAIN = '.getsupermodel.ai';
const COOKIE_MAX_AGE = 60 * 60 * 24 * 365; // 1 year in seconds

function generateIdentifier(): string {
  return `user_${Date.now()}_${Math.random().toString(36).substring(2, 11)}`;
}

function getCookie(name: string): string | null {
  if (typeof document === 'undefined') return null;
  const match = document.cookie.match(new RegExp(`(^| )${name}=([^;]+)`));
  return match ? decodeURIComponent(match[2]) : null;
}

function setCookie(name: string, value: string, domain: string, maxAge: number): void {
  if (typeof document === 'undefined') return;
  document.cookie = `${name}=${encodeURIComponent(
    value
  )}; domain=${domain}; path=/; max-age=${maxAge}; SameSite=Lax; Secure`;
}

/**
 * Gets an existing identifier from cookies or creates a new one.
 * This identifier is shared across all subdomains of getsupermodel.ai
 */
export function getOrCreateSmartlookIdentifier(): string {
  let identifier = getCookie(COOKIE_NAME);

  if (!identifier) {
    identifier = generateIdentifier();
    setCookie(COOKIE_NAME, identifier, COOKIE_DOMAIN, COOKIE_MAX_AGE);
  }

  return identifier;
}

export const useSmartLook = (key?: string) => {
  useEffect(() => {
    if (typeof window !== 'undefined' && !window.location.hostname.match(/^(localhost|127\.|192\.168\.|0\.0\.0\.0)/)) {
      const smartlookKey = key || process.env.REACT_APP_SMARTLOOK_KEY || '';
      if (smartlookKey) {
        const identifier = getOrCreateSmartlookIdentifier();

        Smartlook.init(smartlookKey, {
          region: 'eu',
        });

        // Identify the user with the persistent ID
        Smartlook.identify(identifier, {});
      }
    }
  }, [key]);
};
